import { Component } from '@angular/core';

@Component({
  selector: 'app-sort-horizontal-icon',
  templateUrl: './sort-horizontal-icon.component.html',
  styleUrl: './sort-horizontal-icon.component.scss'
})
export class SortHorizontalIconComponent {

}
